import { defaultState as signupDefaultState } from '@/enums/signup'
import { defineStore } from 'pinia'

// Define proper types for the form structure
interface SizeDesign {
  reference: string | null
  label: string | null
}

interface Design {
  name: string | null
  slug: string | null
}

interface Address {
  streetType: string
  street: string
  floor: string
  houseNumber: number | null
  annex: string
  houseNumberAddition: string
  building: string
  postalCode: string
  city: string
  region: string
}

interface WomenSignupForm {
  'women-bralette': {
    size: SizeDesign
    design: Design
  }
  'women-hipster': {
    size: SizeDesign
    design: Design
  }
  prospectId: string | null
  membershipType: string
  size: SizeDesign
  design: Design
  fixedDesign: Design
  secondaryFixedDesign: Design
  freeMembershipType: string
  freeSize: SizeDesign
  freeDesign: Design
  firstName: string
  lastName: string
  email: string
  password: string
  promotionCode: string
  promotionOffer: string
  consent: boolean
  optIn: boolean
  paymentId: string
  address: Address
}

type WomenSignupBaseState = typeof signupDefaultState

interface WomenSignupState extends Omit<WomenSignupBaseState, 'addressConfirmed' | 'form'> {
  form: WomenSignupForm
  addressConfirmed: boolean
}

export const useWomenSignupStore = defineStore('womenSignup', {
  state: (): WomenSignupState => ({
    ...signupDefaultState,
    addressConfirmed: false
  }),
  actions: {
    setWomenFormField<K extends keyof WomenSignupForm>({ key, value }: { key: K; value: WomenSignupForm[K] }) {
      this.form[key] = value
    },
    setWomenAddressConfirmed(confirmed: boolean) {
      this.addressConfirmed = confirmed
    },
    setWomenAddressField<K extends keyof Address>({ key, value }: { key: K; value: Address[K] }) {
      this.form.address[key] = value
    },
    womenReset() {
      this.form = { ...signupDefaultState.form }
      this.addressConfirmed = false
    },
    womenSetCompleteState(state: Partial<WomenSignupState>) {
      Object.assign(this, state)
    }
  }
})
